import AdminPanel from "pages/Dashboard/AdminPanel";

const Texts = {
    header: {
      returnSibche: "بازگشت به سیبچه",
      exitAcount: "خروج‌ازحساب",
    },
    footer: {
      buttonTxt: "کلیه حقوق متعلق به داده پردازان همراه ایرانیان است. ",
      buttonReadTxt: "بخوانید",

    },
    home: {
      login: "ورود",
      register: "ثبت نام",
    },
   Register: {
    title: "ثبت‌ نام در پنل توسعه‌دهندگان",
    titleMobile: "شماره‌موبایل خود را واردنمایید",
    inputMobile: "شماره موبایل",
    DetailsRgistration:"پس از ثبت شماره موبایل، کد تاییدی برای شما پیامک خواهد شد",
    buttonRegister: " ثبت نام | ورود",
    buttonContinue: "تایید و ادامه",
    support: "تماس با پشتیبانی",
    helpMe: "نیازبه کمک دارید؟",
    loginToAcount:"ورود به حساب کاربری",
  },
  Login: {
    title: "ورد به پنل توسعه دهندگان",
    titleMobile: "شماره‌موبایل خود را واردنمایید",
    inputMobile: "شماره موبایل",
    buttonRegister: "ثبت نام کنید",
    buttonLogin: "ورود به پنل",
    support: "تماس با پشتیبانی",
    helpMe: "نیازبه کمک دارید؟",
    Developer:"حساب توسعه دهنده ندارید؟",
  },
  Verification:{
    buttonEditNumber:"ویرایش شماره موبایل",
    title:"کدتاییدراواردکنید",
    subTitle:"کدتاییدارسال شده به شماره موبایل خود راواردنمایید",
    smsCode:"کدتایید",
    buttonAcceptCode:"تاییدشماره موبایل",
    resendCode:"دریافت مجدد",
  },
  stopper:{
     addIdentifier:"ثبت و تایید شماره موبایل",
     identify:"ایجاد هویت",
     acceptIdentifier:"تایید هویت",
     addFirstApp:"ثبت اولین اپلیکیشن",
  },
  intro:{
    title:"برای حساب خود یک هویت بسازید",
    subTitle:"هویت ساخته شده، به عنوان انتشار دهنده اپلیکیشن شناخته خواهد شد.",
    personalIdentty:"هویت شخصی",
    personalApp:"انتشار دهنده اپلیکیشن یک فرد حقیقی است",
    companyApp:"انتشار دهنده اپلیکیشن یک سازمان حقوقی است",
    reality:"حقیقی",
    legal:"حقوقی",
    companyIdentty:"هویت شرکتی",
    description:"امکان افزودن هویت‌های بیشتر پس از ثبت نام وجود دارد، سخت نگیرید!",
    choosItem:"یک گزینه را انتخاب نمایید",
  },
  PersonalIdentty:{
    fullname:"نام ونام خانوادگی",
    phone:"تلفن ثابت",
    developerName:"نام‌توسعه‌دهنده",
    address:"آدرس",
    nationalCode:"کدملی",
    postallCode:"کدپستی",
    returnIdentity:"بازگشت(نوع هویت)",
    title:"ایجادهویت حقیقی جدید",
    // Shown by the edit form, where "ایجاد ... جدید" is wrong.
    editTitle:"ویرایش هویت حقیقی",
    completedData:"اطلاعات زیرراتکمیل کنید",
    email:"ایمیل",
    ImageIdentity:"عکس کارت ملی",
    uploadImage:"آپولود‌عکس‌عکس‌کارت‌ ملی|حداکثرحجم ۳mb",
    updateFields:"آپلود روزنامه رسمی یا قرارداد حداکثر حجم 3MB",
    error:"لطفا�� تمامی ا��لا��ات را وارد کنید",
    errorEmail:"ایمیل وارد شده ��حیح نمی‌با��د",
    submite:"ثبت وتاییداطلاعات",
  },
  legalIdentty:{
    returnIdentity:"بازگشت(نوع هویت)",
    title:"ایجادهویت حقوقی جدید",
    editTitle:"ویرایش هویت حقوقی",
    completedData:"اطلاعات زیرراتکمیل کنید",
    company:"نام شرکت",
    phone:"تلفن ثابت",
    // A company is identified by an eleven digit شناسه ملی, not the ten digit
    // personal کد ملی. These read "کد ملی" because the legal block was copied
    // from the personal one, so the form asked for the wrong document.
    nationalCode:"شناسه ملی",
    developerName:"نام‌توسعه‌دهنده",
    postallCode:"کدپستی",
    address:"آدرس",
    // The card belongs to the مدیر عامل or the نماینده, not to the company, so
    // the personal wording is correct here — only `nationalCode` above differs
    // between the two identity types.
    ImageIdentity:"عکس کارت ملی",
    gazette:"تصویرقراردادیاروزنامه رسمی",
    uploadImage:"آپولود‌عکس‌عکس‌کارت‌ ملی|حداکثرحجم ۳mb",
    error:"لطفا�� تمامی اطلاعات را وارد کنید",
    errorEmail:"ایمیل وارد شده ��حیح نمی‌با��د",
    submite:"ثبت وتاییداطلاعات",
  },
  Terms:{
    // Split so the article count comes from contractData rather than a
    // hardcoded number that silently goes stale when articles change.
    acceptTermsBefore:"قرارداد را کامل مطالعه کرده و تمام ",
    acceptTermsAfter:" ماده آن را پذیرفته‌ام.",
    title:"قرارداد بهره برداری از حق مولف",
    titleContent:"قرارداد زیر را پس از مطالعه کامل، تایید نمایید:",
    submite:"تایید و پذیرش قرارداد",
    returnIdentity:"بازگشت (ویرایش اطلاعات)",
  },
  Pending:{
    title:"!هویت با موفقیت جهت بررسی ارسال شد",
    // No sms goes out when a publisher is approved or rejected: the call in
    // sibche-5.0's PublisherObserver::updated is commented out. Promising one
    // left the publisher waiting for a message that never arrives.
    subTitle:"تمام مراحل را به خوبی انجام داده‌اید، وضعیت بررسی را می‌توانید از پنل ناشران دنبال کنید.",
    user:"نام کاربری",
    button:"در حال بررسی",
  },
  bande:{
    title:"هویت شما رد شد!",
    subTitle:"نیازی به نگرانی نیست! کافی است موارد زیر را در ارتباط با هویت خود اصلاح نمایید.",
    error:{
      error1:"نام خود را فارسی بنویسید.",
      error2:"عکس کارت ملی باید واضح باشد.",
    },
    buttonEdit:"اصلاح اطلاعات",
    buttonError:"ردشده",
  },
  Approve:{
     title:"هویت شما با موفقیت تایید شد!",
     dashboard:"ورود به داشبورد",
     application:"ثبت اپلیکیشن", 
     accepted:"تایید شده",
  },
  application: {
    cancel: "انصراف",
    titel: "اطلاعات اولیه اپلیکیشن خود را ثبت کنید",
    subTitle: "اپلیکیشن شما به این نام ثبت خواهد خواهدشد",
    subTitle2: "اپلیکیشن شما به نام هویت زیرثبت خواهدشد",
    button: "انتخاب هویت دیگر",
    lablefa: "نام فارسی",
    lableen: "نام انگلیسی",
    category:"دسته بندی",
    submitText: "ثبت اطلاعات اولیه",
    placeholderen:"Example:Snapp,Digikala,Kioosk",
    placeholderfa:"مثلااسنپ!.دیجیکالاو..",
    initApp:"اطلاعات اولیه اپلیکیشن",
  },
  ApplicationStepTow:{
    titel:"فایل اپلیکیشن",
    subTitle:"آپلودکنید IPA فایل اپلیکیشن خود را با فرمت",
    helplink:"برای راهنمایی گرفتن خروجی ایفون اینجا کلیک کنید",
    uploadIpa:"آپلود فایل IPA",
    publish:"انتشار پس از تایید؟",
    active:"فعال",
    dactive:"غیرفعال",
    Description:"در صورت فعال کردن این گزینه، اپلیکیشن بلافاصله پس از تایید در سیبچه منتظر خواهد شد.",
    submitText:"ارسال فایل",
    returnText:"بازگشت (اطلاعات اولیه اپلیکیشن)",
  },
  ApplicationStepThree:{
    returnText:"بازگشت (فایل اپلیکیشن)",
    titel:"اطلاعات زیر را تکمیل کنید",
    lableShort:"توضیح کوتاه",
    lableDescriptionFa:"توضیح کامل فارسی",
    placeHolderFa:"توضیح کامل (تا 2000 کاراکتر)",
    placeHolderEn:"English Descrption (<2000 Char)",
    lableDescriptionEn:"توضیح کامل انگلیسی",
    inAppPurechase:"پرداخت درون برنامه‌ای",
    buttomAdd:"افزودن پکیج",
    submiteText:"ثبت و تایید اطلاعات",
  },
  applicationStepFour:{
    returnText:"بازگشت (فایل اپلیکیشن)",
    titel:"تصاویر اپلیکیشن",
    lableShort:"آیکون اپلیکیشن",
    fomatImage:"فرمت مجاز: PNG یا JPG ",
    sizeImage:"حداکثر اندازه ایکون : 1024 پیکسل ",
    lableDescriptionFa:"تصاویر محیط و معرفی اپلیکیشن",
    uploadIcon:"آپلود فایل آیکون‌",
    uploadFile:"افزودن تصویر",
    submiteText:"تایید و آپلود تصاویر",
  },
   inAppPurchase:{
    returnText:"انصراف",
    title:"ایجاد بسته پرداخت درون برنامه‌ای",
    image:"تصویر بسته",
    signId:"شناسه",
    package:"نام بسته",
    state:"وضعیت",
    price:"قیمت",
    discount:"تخفیف",
    discription:"توضیحات",
    placeholderDiscription:"توضیحات نمایشی به کاربر در خصوص بسته",
    packageName:"نام بسته",
    subPackage:"نوع",
    submiteText:"افزودن بسته",
   },
   dashboard :{
    Identifies:"مدیریت هویت ها",
    Accounting:"گزارشات",
    applications:"اپلیکیشن ها",
    allApps:'همه اپلیکیشن ها',
    activeApps :'اپلیکیشن های فعال',
    show:'نمایش',
   },
   AdminPanel:{
    
      title:"بخش مدیریت ",
      subTitle:"به داشبورد برنامه خوش امدید ",
      choosItem:"درصورت هرگونه سوال با شماره .... تماس حاصل کنید",
   },
  };
  
  export default Texts;
  